import { Klassenbuch } from './../_models/klassenbuch';
import { Component, OnInit, Input } from '@angular/core';
import { Fehlzeiten } from "./../_models/fehlzeiten";
import { Kursteilnehmer } from "./../_models/teilnehmer";
import { Kurs } from '../_models/kurs';
import { KursService } from '../_services/kurs.service';
import { TeilnehmerService } from '../_services/teilnehmer.service';
import { InhalteService } from '../_services/inhalte.service';
import { AnwesenheitService } from '../_services/anwesenheit.service';
import { AuthenticationService } from '../_services/authentication.service';
import { User } from '../_models/user';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

//import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
//import { MatSelectChange } from '@angular/material/select';
//import { MatDialog } from '@angular/material';
//import { SelectionModel } from '@angular/cdk/collections';
//import { InhalteDialogComponent } from '../_components/inhalte.component';
//import { KlassenbuchVergleichDialog } from '../_components/klassenbuchvergleich.component';
//import { AppComponent } from '../app.component';
//import { KursKlassenbuch } from '../_models/KursKlassenbuch';


@Component({
  templateUrl: 'trainer.component.html',
  styles: ['.list-group{max-height: 300px;margin-bottom: 10px;overflow-y: auto;-webkit-overflow-scrolling: touch;}']
})
export class TrainerComponent implements OnInit {
  trainerCoursesToday: Kurs[] = [];
  selectedCourses: Kurs[];
  currentUser: User;
  content: Klassenbuch = new Klassenbuch(new Date());
  isTrainer: boolean;
  absenceChecked = false;
  newContent = true;
  date: Date;
  studentsLoaded: boolean = false;
  AbsenceRecordToDelete: Fehlzeiten;
  updateTime: boolean = false;
  savedTheme: string;
  savedContent: string;
  saved: boolean = true;

  set Content(val: Klassenbuch) {
    if (val != null) {
      if (val.klassenbuchNr > 0)
        this.content = val;
      this.newContent = false;
      this.absenceChecked = true;
      this.savedContent = this.content.inhalte;
      this.savedTheme = this.content.thema;
      return;
    }
    this.content.trainer = this.currentUser.displayName;
    this.content.thema = "";
    this.content.inhalte = "";
    this.newContent = true;
    this.absenceChecked = false;
    this.saved = false;
  }
  constructor(private authService: AuthenticationService, private kService: KursService, private fService: AnwesenheitService, private tService: TeilnehmerService, private iService: InhalteService,private router: Router/*, public dialog: MatDialog*/) {
    //constructor old
    //this.fehlzeit = [];

  }
  ngOnInit() {
    this.currentUser = this.authService.currentUserValue;
    if (this.currentUser.activeRole == 4 || this.currentUser.activeRole == 2) {
      this.isTrainer = true;
    } else {
      this.isTrainer = false;
    }
    let allCourses: Kurs[];
    this.kService.getKurse().subscribe(
      k => { allCourses = k },
      err => console.log(err),
    )
    this.authService.getActiveRoleName;

    let classBookEntriesToday: Klassenbuch[];

    this.iService.GetEntryByTrainerToday(this.currentUser.displayName).subscribe(
      entries => classBookEntriesToday = entries,
      err => console.log(err),
      () => { console.log(classBookEntriesToday); console.log(this.studentsLoaded); }
    );

    this.kService.getCoursesByTrainerToday(this.currentUser.displayName).subscribe(
      courses => this.trainerCoursesToday = courses,
      err => console.log(err),
      () => { console.log(this.trainerCoursesToday); console.log(this.studentsLoaded); }
    );

    //this.iService.getInhalte().subscribe(
    //  contents => {

    //    //console.log("vor filter");
    //    //console.log(classBookEntriesToday);

    //    classBookEntriesToday = contents.filter(
    //      (v, i, a) => {
    //        let gefiltert = (v.eintragsDatum == Fehlzeiten.jsDatetoString()) && (v.trainer == this.currentUser.displayName);
    //        //console.log("Datums:");
    //        //console.log(v.eintragsDatum);

    //        //console.log("new Date");
    //        //console.log(Fehlzeiten.jsDatetoString());

    //        //console.log(v.trainer);
    //        //console.log(this.currentUser.displayName);

    //        //console.log("nach filter");
    //        //console.log(gefiltert);
    //        return gefiltert;
    //      })
    //  },
    //  err => console.log(err),
    //  () => {
    //    if (classBookEntriesToday.length > 0) {
    //      console.log(classBookEntriesToday);
    //      let courseIds: KursKlassenbuch[] = [];
    //      this.iService.GetLookup().subscribe(
    //        l => {
    //          courseIds = l;
    //        },
    //        (err) => console.log(err),
    //        () => {
    //          console.log(courseIds);
    //          courseIds = courseIds.filter((v, i, a) => { return v.klassenbuchNummer == classBookEntriesToday[0].klassenbuchNr });
    //          console.log(courseIds);
    //          console.log(classBookEntriesToday[0].klassenbuchNr);
    //          for (var i = 0; i < courseIds.length; i++) {
    //            this.kService.getKursById(courseIds[i].kursNummer).subscribe(
    //              c => this.selectedCourses.push(c),
    //              err => console.log(err),
    //              () => {
    //                console.log(this.selectedCourses);
    //                this.onAssumeCourses(this.selectedCourses);
    //              }
    //            );
    //          }
    //        }
    //      )
    //    }
    //    //console.log("Klassenbuch:");
    //    //console.log(classBookEntriesToday);
    //  }
    //);

  }

  triggerTime() {
    this.updateTime = !this.updateTime;
  }

  onAssumeCourses(event: Kurs[]) {
    let result: Observable<Kursteilnehmer[]>;
    this.selectedCourses = event;
    this.selectedCourses.forEach(
      (c, i, a) => {
        this.tService.GetTnByKurs(c.kursNr).subscribe(
          tns => { c.teilnehmer = tns },
          err => console.log(err),
          () => {
            c.teilnehmer.forEach(
              (tn, j, arr) => {
                tn.anwesend = true;
                this.fService.getTnFehlzeitenHeute(tn.kursteilnehmerNr).subscribe(
                  fs => tn.fehlzeiten = fs,
                  err => console.log(err),
                  () => {
                    //console.log(tn.fehlzeiten);
                    tn.anwesend = !Kursteilnehmer.hatGanzTagFehlzeit(tn);
                    if (i + 1 == a.length && j + 1 == arr.length) this.studentsLoaded = true;
                    console.log("Nach ganztagspruefing");
                    console.log(tn.fehlzeiten);
                  }
                );
              }
            );
          }
          //() => this.studentsLoaded = true
        )
      }
    );


    this.iService.GetKlassenbuchByKursHeute(this.selectedCourses[0].kursNr).subscribe(
      content => this.Content = content,
      err => console.log(err),
      () => { console.log("entry: "); console.log(this.Content) }
    );

    //console.log(event);
  }

  absenceCheckedClick() {
    this.absenceChecked = !this.absenceChecked;
    if (this.absenceChecked) {
      this.savedContent = this.content.inhalte;
      this.savedTheme = this.content.thema;
    }
  }

  textchanged() {
    if (this.savedTheme != this.content.thema || this.savedContent != this.content.inhalte)
      this.saved = false;
    else
      this.saved = true;
    console.log(this.saved);
    console.log(this.content);
    console.log(this.savedTheme + "\t" + this.savedContent);
  }


  saveContent() {
    this.iService.postInhalte(this.content).subscribe(
      content => this.content = content,
      err => console.log(err),
      () => {
        this.selectedCourses.forEach(
          c => this.iService.postLookup({ kursnummer: c.kursNr, klassenbuchnummer: this.content.klassenbuchNr }).subscribe(
            obs => { },
            err => console.log(err),
            () => { }
          )
        );
        this.saved = true;
        this.savedContent = this.content.inhalte;
        this.savedTheme = this.content.thema;
      }
    )
  }

  IsStudentAbsence(tn: Kursteilnehmer): boolean {
    //console.log(tn);
    //console.log(Kursteilnehmer.hatGanzTagFehlzeit(tn));
    return Kursteilnehmer.hatGanzTagFehlzeit(tn);
  }

  onAbsenceChanged(tn: Kursteilnehmer) {


    tn.anwesend = !tn.anwesend;

    if (!tn.anwesend) {
      let isEmpty: boolean = true;
      tn.fehlzeiten.forEach((v) => {
        if (!(v.von.substr(0, 5) == "08:15" && v.bis.substr(0, 5) == "16:30"))
          isEmpty = false;
      });
      if (isEmpty)
        this.AddAbsence(tn);
      else {
        tn.anwesend = true;
        alert("Individuelle Fehlzeiten zuvor löschen");
      }
    }
    else {
      console.log("tn.fehlzeiten[0]");
      console.log(tn.fehlzeiten[0]);

      this.DeleteAbsence(tn);


    }
  }

  DeleteAbsence(student: Kursteilnehmer) {
    console.log("deleteAbsence");
    let fz: Fehlzeiten[] = student.fehlzeiten.filter(v => v.datum == Fehlzeiten.jsDatetoString());
    if (fz.length > 0) {
      this.fService.delete(fz[0]).subscribe(x => { }, err => console.log(err),
        () => {
          let index = student.fehlzeiten.indexOf(fz[0]);
          console.log(index);
          student.fehlzeiten.splice(index, 1);
        });
    }
  }

  AddAbsence(student: Kursteilnehmer) {
    console.log("addAbsence");
    //let fz: Fehlzeiten = new Fehlzeiten(student.kursteilnehmerNr, false, '', new Date().toISOString().substr(0, 10) + 'T00:00:00');
    let fz: Fehlzeiten = new Fehlzeiten(student.kursteilnehmerNr);
    fz.datum = Fehlzeiten.jsDatetoString();
    fz.bis = "16:30:00";
    fz.von = "08:15:00";
    fz.entschuldigt = false;
    fz.entschuldigung = "unentschuldigt";
    this.fService.postNewTnFehlzeiten(fz).subscribe(x => {
      fz = x;
    }, err => console.log(err),
      () => { student.fehlzeiten.push(fz); }
    );
  }

  cancel() {
    this.router.navigate(["home"]);
  }

  AddAbsenceIsCanceled() {
   
  }
}



// WEBPACK FOOTER //
// ./src/app/trainer/trainer.component.ts